import {ColumnDef} from '@tanstack/react-table';
import {useMemo} from 'react';
import {useIntl} from 'react-intl';
import TableMetronic from '../../../app/common/components/table/TableMetronic';
import {ArpEntry} from '../Types/type';

interface ArpTableProps {
  data: ArpEntry[];
  isLoading?: boolean;
}

const ArpTable = ({data, isLoading}: ArpTableProps): JSX.Element => {
  const intl = useIntl();
  const columns = useMemo<ColumnDef<ArpEntry>[]>(
    () => [
      {
        header: intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.ARP.IP'}),
        accessorKey: 'address',
      },
      {
        header: intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.ARP.MAC'}),
        accessorKey: 'macAddress',
      },
      {
        header: intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.ARP.INTERFACE'}),
        accessorKey: 'interface',
      },
    ],
    [intl]
  );

  return (
    <TableMetronic<ArpEntry>
      data={data}
      columns={columns}
      isLoading={isLoading}
      searchBar={false}
      pagination={false}
      noRowsMessage={intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.ARP.EMPTY'})}
    />
  );
};

export default ArpTable;
